import {Route} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottopilot/_ottopilotScaffold/amaron-campaign-overview/route";
import {EmbeddedPendingComponent} from "~/components/routerHelpers/embeddedPendingComponent";

export function PendingComponent() {
    return (
        <EmbeddedPendingComponent
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            route={Route as any}
        />
    );
}
